<script setup lang="ts">
import { onMounted, provide, ref } from "vue";
import {
  appConfigProviderKey,
  loadAppConfig,
} from "./infrastructure/app_config_provider";
import {
  OrderApi,
  orderApiKey,
} from "./infrastructure/gfo_api/order_api";
import { NetzApi, netzApiKey } from "./infrastructure/gfo_api/netz_api";
import {
  PriceFormatter,
  priceFormatterKey,
} from "./infrastructure/price_formatter";
import ErrorMessage from "./features/Shared/ErrorMessage";
import { WhoamiApi, whoamiApiKey } from "./infrastructure/gfo_api/whoami_api";
import {
  ProductApi,
  productApiKey,
} from "./infrastructure/gfo_api/product_api";
import { InfoApi, infoApiKey } from "./infrastructure/gfo_api/info_api";
import { ApiValidationError } from "./infrastructure/gfo_api/api_validation_error";
import KonfiguratorComponent from "./features/KonfiguratorComponent";
import { ProductInfoProvider, productInfoProviderKey } from "./infrastructure/productinfo_provider";
const props = defineProps<{
  api_token?: string;
  api_url?: string;
  netz_slug?: string;
  checkout_url?: string,
  checker_keys_csv?: string,
  open_groups_csv?: string,
}>();

const initError = ref<string>("");
const initializing = ref<boolean>(true);

// Infrastructure
const appConfig = loadAppConfig(props);
provide(appConfigProviderKey, appConfig);
const orderApi = new OrderApi(appConfig);
provide(orderApiKey, orderApi);
const netzApi = new NetzApi(appConfig);
provide(netzApiKey, netzApi);
const whoamiApi = new WhoamiApi(appConfig);
provide(whoamiApiKey, whoamiApi);
const productApi = new ProductApi(appConfig);
provide(productApiKey, productApi);
const infoApi = new InfoApi(appConfig);
provide(infoApiKey, infoApi);

// Infrastructure
provide(priceFormatterKey, PriceFormatter({ currency: false }));
provide(productInfoProviderKey, new ProductInfoProvider());

// values
const konfiguratorComponentRef = ref<any>(null);

// Initialization
// none
const setCheckerResponse = function(checkerResponse: any){
  const comp = konfiguratorComponentRef.value;
  if (comp){
    comp.handleCheckerResponse(checkerResponse)
  }
}
defineExpose({setCheckerResponse})


onMounted(async () => {
  try {
    // nothing to do
  } catch (err) {
    if (err instanceof ApiValidationError) {
      initError.value = err.title;
      console.log(initError.value)
    } else {
      initError.value = err instanceof Error ? err.message : String(err);
    }
  } finally {
    initializing.value = false;
  }
});
</script>

<template>
  <div v-if="initializing">Laden...</div>
  <div v-if="!initializing && initError != ''">
    <ErrorMessage :message="initError"></ErrorMessage>
  </div>
  <KonfiguratorComponent v-if="!initializing && initError == ''" ref="konfiguratorComponentRef"></KonfiguratorComponent>

</template>
